import WIDGETS from './widgets';

export default {
	name: 'kind_chat_user_manage_notes',
	spacing: 1,
	sx: { width: '100%' },
	widgets: [{ content: WIDGETS.CHAT_USER_MANAGE_NOTES, breakpoints: { xs: 12, sm: 12 }, lazy_loading: 0 }],
};
